export default __webpack_public_path__ + "static/innovator-1--mobile-4b6906166d75dbdffec99cb52091aceb.png";